export enum EKitchenBarMode {
  Combined = 0,
  Separated = 1,
}
